import React, {useState, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate, createSearchParams } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, Button, Paper, Skeleton } from "@mui/material";
import '../styles/reset.css'

import pwreset, { fetchPWReset, fetchPWResetAuth, pwresetClearUpdate, updatePassword, updatePasswordAuth } from "../reducers/pwreset";
import {updateUserPWState} from "../reducers/auth"
import Footer from "./layouts/Footer";

const PasswordReset = (props) => {
  
  const navigate = useNavigate()
  const [callVI, setCallVI] = useState(false)
  const [searchParams] = useSearchParams();
  const viewInstance = useSelector(state => state.pwreset.entities)
  const settings = useSelector(state => state.pwreset.settings)
  const PWResetStatus = useSelector(state => state.pwreset.status)
  const PWResetError = useSelector(state => state.pwreset.error)
  const PWResetStatusUpdate = useSelector(state => state.pwreset.statusUpdate)
  const {user: currentUser} = useSelector(state => state.auth)
  //const viewInstance = vi
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword1] = useState("")
  const [checkPassword, setPassword2] = useState("")
  const [rules, setRules] = useState(null)
  const [disableSave, setDisableSave] = useState(true)
  const [updatedPassword, setUpdatedPassword] = useState(false)
  const [arrayOfInvalidPasswords, setArrayOfInvalidPasswords] = useState([])
  const [passRules, setPassRules] = useState([])
  
  

  const dispatch = useDispatch()

  useEffect(() => {
    if(!rules){
      setRules(passRules)
    }



    if(PWResetStatus == 'idle'){
      setCallVI(true)
      
      let group = searchParams.get("pwrg")
      if(group){
        dispatch(fetchPWReset(group))
      } else {
        dispatch(fetchPWResetAuth(currentUser.AuthToken))
      }
    }
    dispatch(pwresetClearUpdate())


  },[window.location.pathname])

  useEffect(() => {
    if(viewInstance && viewInstance.PasswordResetPage && viewInstance.PasswordResetPage.PwdExclusions && viewInstance.PasswordResetPage.PwdExclusions.length && viewInstance.PasswordRulesFrame.PwdExclusions!= '-1'){
      setArrayOfInvalidPasswords(viewInstance.PasswordRulesFrame.PwdExclusions.split(',').map(x => x.toLowerCase()))
    }
  }, [viewInstance])

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  };



  const handlePasswordChange = () => (event) => {
    setPassword1(event.target.value)
    let rules = 0, passed = 0
    passRules.forEach((rule) => {
      if(rule.Enabled == "1"){
        rules++
        if(rule.CheckFunction(event.target.value)){
          rule.Pass = true
          passed++
        } else {
          rule.Pass = false
        }
      }
      if(rules == passed){
        setDisableSave(false)
      } else {
        setDisableSave(true)
      }
    })

    setRules(passRules)
  }

  const handleCheckChange = () => (event) => {
    setPassword2(event.target.value)
    let rules = 0, passed = 0
    passRules.forEach((rule) => {
      if(rule.Enabled == "1"){
        rules++
        if(rule.CheckFunction(password)){
          rule.Pass = true
          passed++
        } else {
          if(rule.Name == "ConfirmPassMatch" && password == event.target.value) {
            rule.Pass = true
            passed++ 
          } else {
            rule.Pass = false
          }
        }
      }
      if(rules == passed){
        setDisableSave(false)
      } else {
        setDisableSave(true)
      }
    })

    setRules(passRules)
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = () => {
    const escapedPassword = encodeURI(password)
    let group = searchParams.get("pwrg")
    if(group){
      dispatch(updatePassword({
          Password: escapedPassword,
          PwrGuid: group,
          Username: '~~'
        }))
    } else {
        dispatch(updatePasswordAuth({
          Password: escapedPassword,
          AuthToken: currentUser.AuthToken,
          ParticipantGuid: settings.SessionVariableValues['PERSON GUID'],
          Username: "~~",
          PasswordChangeRequired: '0'
        }))
    }
  }

  const handleRedirect = () => {
    const group = searchParams.get("pwrg")
    dispatch(pwresetClearUpdate())
    if(group){
      const groupguid = settings.SessionVariableValues.List['ORGANIZATION GUID']
      navigate({ pathname: '/login', search: createSearchParams({ g: groupguid }).toString() })
    } else {
      dispatch(updateUserPWState(false))
      navigate('/home')
    }
  }

  useEffect(() => {
    if(PWResetStatusUpdate=="success"){
      handleRedirect()
    }
  }, [PWResetStatusUpdate])

useEffect(() => {
  if(viewInstance && viewInstance.PasswordResetPage && !passRules.length){
    setPassRules(
      [{
        Name: 'DoNotReusePrevious',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdPreviousAllowed,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdPreviousAllowed == "1" ? "0" : "1",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.DoNotReusePreviousPrompt,
        Pass: true,
        CheckFunction: function(){
          return true;
        }
      },
      {
        Name: 'InvalidPwd',
        Value: arrayOfInvalidPasswords,
        Enabled: arrayOfInvalidPasswords.length > 0 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.InvalidPwdPrompt.split(':')[0] + ': ',
        Pass: arrayOfInvalidPasswords.length > 0 ? false : true,
        CheckFunction: function(pw){
          if (pw.indexOf(password.toLowerCase()) == -1 ) {
            return true;
          }
        }
      },
      {
        Name: 'InvalidPwdUsername',
        Value: viewInstance.PasswordResetPage.UserInformation.PersonUserName,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdUsernameAllowed == "1" ? "0" : "1",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.InvalidPwdUsernamePrompt,
        Pass: true,
        CheckFunction: function(pw){
          if ( checkPassword != viewInstance.PasswordResetPage.UserInformation.PersonUserName && pw != viewInstance.PasswordResetPage.UserInformation.PersonUserName ) {
            return true;
          }
        }
      },
      {
        Name: 'LengthMax',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMaxLength,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMaxLength > 0 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.LengthMaxPrompt,
        Pass: false,
        CheckFunction: function(pw){
          if (pw.length <= this.Value) {
            return true;
          }
        }
      },
      {
        Name: 'LengthMin',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinLength,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinLength > -1 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.LengthMinPrompt,
        Pass: false,
        CheckFunction: function(pw){
          if (pw.length >= this.Value ) {
            return true;
          }
        }
      },
      {
        Name: 'LowerCaseCharMin',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinLowerCase,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinLowerCase > -1 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.LowerCaseCharMinPrompt,
        Pass: false,
        CheckFunction: function(pw){
          var passwordRegExMatchLength = pw.match(/[a-z]/g) ? pw.match(/[a-z]/g).length : 0;
          if (passwordRegExMatchLength >= this.Value) {
            return true;
          }
          return false;
        }
      },
      {
        Name: 'NumericCharMin',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinNumeric,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinNumeric > -1 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.NumericCharMinPrompt,
        Pass: false,
        CheckFunction: function(pw){
          var passwordRegExMatchLength = pw.match(/[0-9]/g) ? pw.match(/[0-9]/g).length : 0;
          if (passwordRegExMatchLength >= this.Value) {
            return true;
          }
          return false;
        }
      },
      {
        Name: 'SpecialCharMin',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinSpecial,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinSpecial > -1 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.SpecialCharMinPrompt,
        Pass: false,
        CheckFunction: function(pw){
          var passwordRegExMatchLength = pw.match(/[~`!@#$%&*()_+={}:;<>,|\s\'\.\?\-\^\[\]\\\"]/g) ? pw.match(/[~`!@#$%&*()_+={}:;<>,|\s\'\.\?\-\^\[\]\\\"]/g).length : 0;
          if (passwordRegExMatchLength >= this.Value) {
            return true;
          }
          return false;
        }
      },
      {
        Name: 'UpperCaseCharMin',
        Value: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinUpperCase,
        Enabled: viewInstance.PasswordResetPage.PasswordRulesFrame.PwdMinUpperCase > -1 ? "1" : "0",
        Prompt: viewInstance.PasswordResetPage.PasswordRulesFrame.UpperCaseCharMinPrompt,
        Pass: false,
        CheckFunction: function(pw){
          var passwordRegExMatchLength = pw.match(/[A-Z]/g) ? pw.match(/[A-Z]/g).length : 0;
          if (passwordRegExMatchLength >= this.Value) {
            return true;
          }
          return false;
        }
      },
      {
        Name: 'ConfirmPassMatch',
        Value: '',
        Enabled: "1",
        Prompt: viewInstance.PasswordResetPage.PasswordResetConfirmPasswordFrame.PasswordResetConfirmPasswordErrorMessage,
        Pass: false,
        CheckFunction: function(pw){
          if ( checkPassword == pw) {
            return true;
          }
        }
      }]
    )
  }
}, [viewInstance])

  const ruleListJSX = rules ? rules.map((rule) => {
    if(rule.Enabled == "1"){
    return <li class={rule.Pass ? "pass": "fail"}><CheckCircleIcon style={{display: rule.Pass ? '' : 'none'}}/><CancelIcon style={{display: rule.Pass ? 'none' : ''}}/>
    {rule.Prompt}
    {rule.Name == "InvalidPwd" && (
      <ul>
        {arrayOfInvalidPasswords.map(ar => (
          <li>{ar}</li>
        ))}
      </ul>
    )}
    </li>
    }
  }) : null
  if(viewInstance && viewInstance.PasswordResetPage){
    return (
      <Box>
    <Paper elevation={16}>
      <div class="container base">
        <h3>
        {viewInstance.PasswordResetPage.PasswordResetTitle}
        </h3>
        <p>{viewInstance.PasswordResetPage.PasswordResetHelpText}</p>
      <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" style={{width:'100%'}}>
          <InputLabel htmlFor="outlined-adornment-password">{viewInstance.PasswordResetPage.PasswordResetNewPasswordFrame.PasswordResetNewPasswordTextBoxPrompt}</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password} 
            onChange={handlePasswordChange()}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label={viewInstance.PasswordResetPage.PasswordResetNewPasswordFrame.PasswordResetNewPasswordTextBoxPrompt}
            placeholder={viewInstance.PasswordResetPage.PasswordResetNewPasswordFrame.PasswordResetNewPasswordTextBoxPrompt}
          />
        </FormControl>
      <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined" style={{width:'100%'}}>
          <InputLabel htmlFor="outlined-adornment-password">{viewInstance.PasswordResetPage.PasswordResetNewPasswordFrame.PasswordResetNewPasswordTextBoxPrompt}</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={checkPassword}
            onChange={handleCheckChange()}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label={viewInstance.PasswordResetPage.PasswordResetConfirmPasswordFrame.PasswordResetConfirmPasswordTextBoxPrompt}
            placeholder={viewInstance.PasswordResetPage.PasswordResetConfirmPasswordFrame.PasswordResetConfirmPasswordTextBoxPrompt}
          />
        </FormControl>
        <Button variant="contained"
          size="large" 
          disabled={disableSave} style={{width:'100%'}} onClick={handleSubmit}>{viewInstance.PasswordResetPage.PasswordResetSubmitButton}</Button>

      <p>{viewInstance.PasswordResetPage.PasswordResetpasswordRulesFrame.PasswordResetpasswordRulesTitle1}</p>
      <p>{viewInstance.PasswordResetPage.PasswordResetpasswordRulesFrame.PasswordResetpasswordRulesTitle2}</p>
      <ul>
       {ruleListJSX} 
      </ul>
      <p>{PWResetError}</p>
      </div>
    </Paper>
    <Footer settings={settings}/>
    </Box>
  );
  } else { return (
    <Paper elevation={16}>
      <Skeleton variant="rectangular" width={210} height={118} />
    </Paper>
  )}
  
};

export default PasswordReset;